import { LabelFormatDetailsDto, LabelFormatDetailsModel } from '../types/label-format-details'

export const transformLabelFormatDetails = (
  labelFormatDetail: LabelFormatDetailsDto,
): LabelFormatDetailsModel => ({
  iconUrl: labelFormatDetail.icon_url,
  title: labelFormatDetail.title,
  subtitle: labelFormatDetail.subtitle,
})
